import { Factory, association } from 'miragejs'
import { faker } from '@faker-js/faker'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

export default Factory.extend({
  partner: association(),

  subscriptionType() {
    return faker.helpers.arrayElement([SubscriptionType.Reading, SubscriptionType.Maths, SubscriptionType.Writing])
  },

  schoolSupportEmail() {
    return faker.internet.exampleEmail({ firstName: 'school', lastName: 'support' }) // eg school_support42@example.com
  },

  schoolSupportPhone() {
    return faker.phone.number()
  },

  schoolSupportPhoneHours() {
    return 'Mon - Fri, 9am - 5pm EST. Sat - 10am - 2pm EST.'
  },

  schoolSupportPhoneTollFree() {
    return faker.datatype.boolean()
  },

  schoolSalesEmail() {
    return faker.internet.exampleEmail({ firstName: 'school', lastName: 'sales' })
  },

  schoolSalesPhone() {
    return faker.phone.number()
  },

  schoolSalesPhoneHours() {
    return 'Mon - Fri, 9am - 5pm EST. Sat - 10am - 2pm EST.'
  },

  schoolSalesPhoneTollFree() {
    return faker.datatype.boolean()
  },

  cleverSupportEmail() {
    return faker.internet.exampleEmail({ firstName: 'clever' })
  },

  address() {
    return faker.location.streetAddress({ useFullAddress: true })
  },
})
